import * as React from "react";
import { useState, useEffect, useContext, useMemo } from "react";
import { BrowserRouter as Router, Link, useLocation } from "react-router-dom";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import { confirmAlert } from "react-confirm-alert";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

/* ICONES */
import FileUploadIcon from "@mui/icons-material/FileUpload";
import ApprovalIcon from "@mui/icons-material/Approval";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ReplayIcon from "@mui/icons-material/Replay";
import SaveIcon from "@mui/icons-material/Save";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import IconButton from "@mui/material/IconButton";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import Download from "@mui/icons-material/Download";

/* Dialog */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

/* DADOS */
import ForecastDataSet from "../../components/data/ForecastDataSet";
import ForecastDataSetPortal from "../../components/data/ForecastDataSetPortal";

/* CLASSES */
import Forecast from "../../components/classes/Forecast";
import Contrato from "../../components/classes/Contrato";
import UnidadeArmazenamento from "../../components/classes/UnidadeArmazenamento";
import UnidadeArmazenamentoDataset from "../../components/data/UnidadeArmazenamentoDataSet";

/* COMPONENTES CUSTOMIZADOS */
import ForecastTopo from "./topo";
import ForecastPassoAPasso from "./forecastPassos";
import FileUpload from "../../components/common/FileUpload";
import PageHelper from "../../helper/pageHelper";

/* LOCALIZAÇÃO */
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers";
import { ptBR } from "date-fns/locale";

/* D O W N L O A D */
import { CSVLink, CSVDownload } from "react-csv";
import { Send } from "@mui/icons-material";
import {
  Alert,
  FormControl,
  Grid,
  InputLabel,
  Modal,
  Select,
  Snackbar,
  TextField,
} from "@mui/material";
import ForecastModal from "./forecastModal";
import SkuDescricao from "../../components/common/SkuDescricao";
import { UserContext } from "../../App";
import DownloadCSVModal from "../../components/common/DownloadCSVModal/DownloadCSVModal";
import Utils from "../../helper/utils";
import CSVDetalhesModal from "../../components/common/CSVDetalhesModal/CSVDetalhesModal";

import styles from "./detail.module.css";
import { GridFilterInputValueProps } from "@mui/x-data-grid/components";
import AutocompleteSKU from "../../components/common/AutocompleteSku";
import StepLogsHistoryDetalhe from "../../components/common/StepLogsHistoryModal/StepLogsHistoryDetalhe";

import { useTranslation } from "react-i18next";

enum FILTER_NAMES {
  codigoSku = "skus",
  descricaoSku = "descricaoSku",
  centroDistribuicao = "centro",
  quantidade = "quantidade",
  mesAnoReferencia = "mesAnoReferencia",
}
interface FilterProps {
  [FILTER_NAMES.codigoSku]: string[];
  [FILTER_NAMES.descricaoSku]: string;
  [FILTER_NAMES.centroDistribuicao]: string;
  [FILTER_NAMES.quantidade]: string;
  [FILTER_NAMES.mesAnoReferencia]: Date | null;
}

/* G R I D */
interface Data {
  id: number;
  codigoFornecedorSap: number;
  numeroContrato: string;
  idSku: string;
  descricao: string;
  centro: string;
  anoMesRef: string;
  quantidade: number;
  quantidadeProposta: number;
  justificativa: string;
  gerouForecastDiario: string;
  projeto: string;
  origem: string;
  siglaSku: string;
}

interface download {
  idSku: string;
  centro: string;
  dia: string;
  quantidade: string;
  justificativa: string;
}

export default function ForeCastPage() {
  const { t } = useTranslation();

  const user: any = useContext(UserContext);

  const [habilita, setHabilita] = useState(false);

  const [loading, setLoading] = useState(true);
  const [historyId, setHistoryId] = useState(0);

  /* MODAL */
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openDownloadCSVModal, setOpenDownloadCSVModal] =
    useState<boolean>(false);
  const [openCSVDetalhesModal, setOpenCSVDetalhesModal] =
    useState<boolean>(false);
  const [openSnackBar, setOpenSnackBar] = useState<boolean>(false);
  const [csvFoiEnviado, setCsvFoiEnviado] = useState<{
    wasUpdated: boolean;
    isSuccess: boolean;
    details: string;
  }>({ wasUpdated: false, isSuccess: false, details: "" });

  /* PAGINAÇÃO */
  const [filtra, setFiltra] = React.useState(false);
  const [pageSize, setPageSize] = useState(50);
  const [step, SetStep] = useState(0);
  const [titleAprova, SetTitleAprova] = useState("");
  const [valorAnterior, SetValorAnterior] = useState(0);

  const [forecasts, setForecasts] = useState<Forecast[]>([]);
  const [forecastsTemp, setForecastsTemp] = useState<Forecast[]>([]);
  const dataForecast: ForecastDataSet = new ForecastDataSet();
  const dataForecastPortal: ForecastDataSetPortal = new ForecastDataSetPortal();
  const dataSKU: UnidadeArmazenamentoDataset =
    new UnidadeArmazenamentoDataset();
  const codigoFornecedorSap: number = Number(
    localStorage.getItem("CodigoFornecedorSAPSelecionado")
  );

  /* FILTER */
  const [filter, setFilter] = useState({} as FilterProps);
  /** @deprecated */
  const [codigoSku, setCodigoSku] = React.useState("");
  /** @deprecated */
  const [descricaoSku, setDescricaoSku] = React.useState("");
  /** @deprecated */
  const [centroDistribuicao, setCentroDistribuicao] = React.useState("");
  /** @deprecated */
  const [mesAnoReferencia, setMesAnoReferencia] = React.useState<Date | null>(
    null
  );
  /** @deprecated */
  const [quantidade, setQuantidade] = React.useState("");
  const [alterado, setAlterado] = React.useState<boolean>(false);

  /* G R I D */
  const [rows, setRows] = useState<Data[]>([]);

  const handleChangeFilter = React.useCallback((event) => {
    setFilter((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  }, []);

  function useQuery() {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  let _step: number =
    query.get("step")?.valueOf() === undefined
      ? 1
      : Number(query.get("step")?.valueOf());
  if (_step !== step && _step > 0 && _step < 5) {
    SetStep(_step);
    var title: string = t("pages.monthlyForecast.text.approvalDataTitle");
    title =
      title +
      (_step === 3 ? t("pages.monthlyForecast.text.approvalDataTitle2") : "");
    SetTitleAprova(title);
  }

  const Input = styled("input")({
    display: "none",
  });

  var _contrato: Contrato =
    localStorage.getItem("ContratoSelecionado") === null ||
    localStorage.getItem("ContratoSelecionado") === undefined
      ? console.log(t("pages.monthlyForecast.text.contractNotSelected"))
      : JSON.parse(String(localStorage.getItem("ContratoSelecionado")));

  const numeroContrato: string = String(
    _contrato !== null && _contrato !== undefined
      ? _contrato.numeroContrato
      : t("pages.monthlyForecast.text.withoutContract")
  );

  useEffect(() => {
    const fetchData = async () => {
      Utils.setDocumentTitle(
        numeroContrato.valueOf(),
        `| Step ${step} - ${t("pages.monthlyForecast.titlePage")}`
      );
      const data = await dataForecast.ListarAtivosPorPasso(
        codigoFornecedorSap,
        numeroContrato,
        step
      );
      if (data) {
        setForecasts(data);
        setForecastsTemp(data);
        preencherGrid(data);
      }
      setLoading(false);
    };
    fetchData().catch(console.error);
  }, []);

  useEffect(() => {
    setOpen(false);
    if (csvFoiEnviado.wasUpdated) {
      setOpenSnackBar(true);
      if (csvFoiEnviado.isSuccess) {
        setLoading(true);
        dataForecast
          .ListarAtivosPorPasso(codigoFornecedorSap, numeroContrato, step)
          .then((data) => {
            if (data) {
              preencherGrid(data);
              setForecasts(data);
            }
            setLoading(false);
          });
      }
    }
  }, [csvFoiEnviado]);

  const handleIntegracaoPlanoBase = () => {
    let ids: string[] = String(localStorage.getItem("idsForecast")).split(",");
    let count: number = 0;
    MensagemBackgoundProcess(ids.length);
    ids.map((id: string) => {
      let reg: Forecast = forecasts.filter((f) => f.id === Number(id))[0];
      count += 1;
      dataForecastPortal.Integra(reg, "Mensal");
    });
    let quantityItems = ids.length;
    Mensagem(
      t("common.warning"),
      quantityItems > 1
        ? t("pages.monthlyForecast.text.integratedSelectedItems", {
            quantityItems,
          })
        : `${t("pages.monthlyForecast.text.integratedSelectedItems")} \n\r`
    );
  };

  const handleClickSave = () => {
    let ids: string[] = String(localStorage.getItem("idsForecast")).split(",");
    let upgradableForecast: Forecast[] = [];
    MensagemBackgoundProcess(ids.length);
    ids.forEach((id: string) => {
      let reg: Forecast | undefined = forecasts.find(
        (f) => f.id === Number(id)
      );
      if (reg) {
        reg.step = step;
        upgradableForecast.push(reg);
      }
    });
    dataForecast.AtualizarColecao(upgradableForecast).then((result) => {
      let quantityItems = ids.length;
      if (result) {
        Mensagem(
          t("common.warning"),
          ids.length > 1
            ? t("pages.monthlyForecast.text.updatedSelectedItems", {
                quantityItems,
              })
            : `${t("pages.monthlyForecast.text.updatedSelectedItems2")} \n\r`
        );
      } else {
        Mensagem(
          t("common.error"),
          ids.length > 1
            ? t("pages.monthlyForecast.text.errorSelectedItems", {
                quantityItems,
              })
            : `${t("pages.monthlyForecast.text.errorSelectedItems2")} \n\r`
        );
      }
    });
  };

  const handleConfimation = (titulo: string, mensagem: string) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: "Sim",
          onClick: async () => {
            await setOpen(false);
            handleClickAprove();
          },
        },
        {
          label: "Não",
          onClick: () => {
            setOpen(false);
          },
        },
      ],
    });
  };

  function handleClickDadosForecast() {
    setOpenModal(true);
  }

  function handleClickEstornarForecast() {
    /**
     *  TODO front responsável, implementar aqui sistema de estorno
     *
     *  1- Baseado na informação deste contrato específico, apagar todos os
     *     forecasts gerados baseado no SKU específico no banco de dados.
     *  2- Apagar também registros relacionadas ao Produto Acabado no STEP 1
     *     com o Contrato e SKU no banco de dados.
     *  3- Na tela de ContratoItemGrid, definir o 'gerouForecast' do item do contrato
     *     referente a este SKU como "false", assim permitindo que o usuário
     *     apague aquele contrato e crie um novo contrato com o SKU correto.
     *
     *
     * Por quê?
     *     O usuário, ao gerar Forecasts para um SKU específico na tela de contrato, pode
     *     ter, acidentalmente, inserido um SKU incorreto, gerando Forecasts indesejados
     *     que vão acumular e depender da ação manual de alguém para removê-los.
     *     Essa funcionalidade passará a existir para que assim o usuário possa desfazer
     *     o erro cometido com Forecasts inapropriados.
     *
     * A quem contatar?
     *     Por se tratar de um processo delicado e relativamente complexo, onde várias entidades
     *     estão envolvidas, convém falar com o Anderson para o entendimento da lógica por trás
     *     do código tanto aqui no Front, quanto no Back.
     *     No mais, para melhores esclarecimentos, falar com o pessoal da BRF.
     */
  }

  const handleClickAprove = () => {
    let ids: string[] = String(localStorage.getItem("idsForecast")).split(",");
    let upgradableForecast: Forecast[] = [];
    MensagemBackgoundProcess(ids.length);
    for (const id of ids) {
      let reg: Forecast | undefined = forecasts.find(
        (f) => f.id === Number(id)
      );
      if (reg) {
        if (
          step === 2 &&
          reg.quantidadeProposta > 0 &&
          reg.quantidadeProposta !== reg.quantidade &&
          !reg.justificativa
        ) {
          upgradableForecast = [];
          Mensagem(
            t("common.warning"),
            t("pages.monthlyForecast.text.proposalQuantityIsWrong"),
            false
          );
          break;
        } else {
          reg.aprovadoBRF = step === 1 || step === 3;
          reg.aprovadoParceiro = step === 2; // || step === 4;

          upgradableForecast.push(reg);
        }
      }
    }

    if (upgradableForecast.length > 0) {
      atualizarColecao(true, upgradableForecast, ids);
    }
  };

  const handleClickNotAprove = () => {
    let ids: string[] = String(localStorage.getItem("idsForecast")).split(",");
    let upgradableForecast: Forecast[] = [];
    MensagemBackgoundProcess(ids.length);
    ids.forEach((id: string) => {
      let reg: Forecast | undefined = forecasts.find(
        (f) => f.id === Number(id)
      );
      if (reg) {
        reg.aprovadoBRF = false;
        upgradableForecast.push(reg);
      }
    });
    atualizarColecao(false, upgradableForecast, ids);
  };

  async function atualizaListaForecast() {
    const data = await dataForecast.ListarAtivosPorPasso(
      codigoFornecedorSap,
      numeroContrato,
      step
    );
    setForecasts(data);
    preencherGrid(data);
  }

  function atualizarColecao(
    approve: boolean,
    upgradableForecast: Forecast[],
    ids: string[]
  ) {
    setLoading(true);
    var complemento: string =
      step === 50 ? t("pages.monthlyForecast.text.rememberThisOperation") : "";
    let quantityItems = ids.length;
    dataForecast
      .AtualizarColecao(upgradableForecast)
      .then((result) => {
        atualizaListaForecast().then(() => {
          setLoading(false);
          if (result) {
            if (approve) {
              Mensagem(
                t("common.warning"),
                ids.length > 1
                  ? t("pages.monthlyForecast.text.selectedItemsNextForecast", {
                      quantityItems,
                    }) + complemento
                  : t("pages.monthlyForecast.text.selectedItemsNextForecast2") +
                      complemento,
                true
              );
            } else {
              Mensagem(
                t("common.warning"),
                ids.length > 1
                  ? t(
                      "pages.monthlyForecast.text.selectedItemsNextForecastError",
                      { quantityItems }
                    )
                  : t(
                      "pages.monthlyForecast.text.selectedItemsNextForecastError2"
                    ),
                true
              );
            }
          } else {
            if (approve) {
              Mensagem(
                t("common.error"),
                ids.length > 1
                  ? t(
                      "pages.monthlyForecast.text.selectedItemsProcessedWithError",
                      { quantityItems }
                    ) + complemento
                  : t(
                      "pages.monthlyForecast.text.selectedItemsProcessedWithError2"
                    ) + complemento,
                true
              );
            } else {
              Mensagem(
                t("common.error"),
                ids.length > 1
                  ? t(
                      "pages.monthlyForecast.text.selectedItemsDoesNotProcessed",
                      { quantityItems }
                    )
                  : t(
                      "pages.monthlyForecast.text.selectedItemsDoesNotProcessed2"
                    ),
                true
              );
            }
          }
        });
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        Mensagem(
          t("common.error"),
          ids.length > 1
            ? t("pages.monthlyForecast.text.selectedItemsDoesNotProcessed", {
                quantityItems,
              })
            : t("pages.monthlyForecast.text.selectedItemsDoesNotProcessed2"),
          true
        );
      });
  }

  const columns: GridColumns = MontaColunas(step);

  function MontaColunas(_step: number): GridColumns {
    let cols: GridColumns = [];
    if (step === 1 || step === 0) {
      cols = [
        {
          field: "id",
          headerName: "#",
          width: 80,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "hist",
          headerName: t("common.historic"),
          width: 80,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => (
            <Tooltip title={t("common.viewHistoric")}>
              <span>
                <IconButton onClick={() => setHistoryId(params.row.id)}>
                  <HistoryToggleOffIcon />
                </IconButton>
              </span>
            </Tooltip>
          ),
        },
        {
          field: "idSku",
          headerName: t("common.skuCode"),
          type: "number",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "siglaSku",
          headerName: t("common.acronym"),
          type: "string",
          width: 190,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "descricao",
          headerName: t("common.skuDescription.label"),
          type: "string",
          width: 400,
          editable: false,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => <SkuDescricao value={params.value} />,
        },
        {
          field: "centro",
          headerName: t("common.center"),
          type: "number",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "projeto",
          headerName: t("common.project"),
          type: "string",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "anoMesRef",
          headerName: t("pages.monthlyForecast.text.monthYearRef"),
          type: "string",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
          sortingOrder: Utils.sorterColumn().sortingOrder(),
          sortComparator: Utils.sorterColumn().sortComparator(
            "MM/YYYY"
          )<String>,
        },
        {
          field: "quantidade",
          headerName: t("common.quantity"),
          type: "number",
          width: 150,
          editable: true,
          align: "center",
          headerAlign: "center",
          valueFormatter: (params) => round3(params.value) + " Kg",
          cellClassName: (gridItem: any) => {
            let forecastAtual = forecastsTemp.find(
              (forecast) => forecast.id == gridItem.id
            );
            if (forecastAtual) {
              return forecastAtual.quantidade + " Kg" != gridItem.formattedValue
                ? "celulaAlterada"
                : "";
            }
            return "";
          },
        },
      ];
    }
    if (step === 2 || step === 3) {
      cols = [
        {
          field: "id",
          headerName: "#",
          width: 80,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "hist",
          headerName: t("common.historic"),
          width: 80,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => (
            <Tooltip title={t("common.viewHistoric")}>
              <span>
                <IconButton onClick={() => setHistoryId(params.row.id)}>
                  <HistoryToggleOffIcon />
                </IconButton>
              </span>
            </Tooltip>
          ),
        },
        {
          field: "idSku",
          headerName: t("common.sku"),
          type: "number",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "siglaSku",
          headerName: t("common.acronym"),
          type: "string",
          width: 190,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "descricao",
          headerName: t("common.skuDescription.label"),
          type: "string",
          width: 400,
          editable: false,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => <SkuDescricao value={params.value} />,
        },
        {
          field: "centro",
          headerName: t("common.center"),
          type: "number",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "projeto",
          headerName: t("common.project"),
          type: "string",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "anoMesRef",
          headerName: t("pages.monthlyForecast.text.monthYearRef"),
          type: "string",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
          sortingOrder: Utils.sorterColumn().sortingOrder(),
          sortComparator: Utils.sorterColumn().sortComparator(
            "MM/YYYY"
          )<String>,
        },
        {
          field: "quantidade",
          headerName: t("common.plannedQuantity"),
          type: "number",
          width: 160,
          editable: false,
          align: "center",
          headerAlign: "center",
          valueFormatter: (params) => round3(params.value) + " Kg",
        },
        {
          field: "quantidadeProposta",
          headerName: t("common.proposedQuantity"),
          type: "number",
          width: 150,
          editable: true,
          align: "right",
          headerAlign: "center",
          valueFormatter: (params) => round3(params.value) + " Kg",
          cellClassName: (gridItem: any) => {
            let forecastAtual = forecastsTemp.find(
              (forecast) => forecast.id == gridItem.id
            );
            if (forecastAtual) {
              return forecastAtual.quantidadeProposta + " Kg" !=
                gridItem.formattedValue
                ? "celulaAlterada"
                : "";
            }
            return "";
          },
          valueSetter: (params) => {
            if (params.row.quantidadeProposta != params.value && _step == 3)
              setAlterado(true);

            return { ...params.row, quantidadeProposta: params.value };
          },
        },
        {
          field: "justificativa",
          headerName: t("common.justify"),
          width: 200,
          editable: true,
          align: "center",
          headerAlign: "center",
          type: "string",
          renderCell: (params) => <SkuDescricao value={params.value} />,
          cellClassName: (gridItem: any) => {
            let forecastAtual = forecastsTemp.find(
              (forecast) => forecast.id == gridItem.id
            );
            if (forecastAtual) {
              return forecastAtual.justificativa != gridItem.formattedValue
                ? "celulaAlterada"
                : "";
            }
            return "";
          },
        },
      ];
    }
    if (step === 4) {
      cols = [
        {
          field: "id",
          headerName: "#",
          width: 80,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "hist",
          headerName: t("common.historic"),
          width: 80,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => (
            <Tooltip title={t("common.viewHistoric")}>
              <span>
                <IconButton onClick={() => setHistoryId(params.row.id)}>
                  <HistoryToggleOffIcon />
                </IconButton>
              </span>
            </Tooltip>
          ),
        },
        {
          field: "idSku",
          headerName: t("common.skuCode"),
          type: "number",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "siglaSku",
          headerName: t("common.acronym"),
          type: "string",
          width: 190,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "descricao",
          headerName: t("common.skuDescription.label"),
          type: "string",
          width: 400,
          editable: false,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => <SkuDescricao value={params.value} />,
        },
        {
          field: "centro",
          headerName: t("common.center"),
          type: "number",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "projeto",
          headerName: t("common.project"),
          type: "string",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "anoMesRef",
          headerName: t("pages.monthlyForecast.text.monthYearRef"),
          type: "string",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
          sortingOrder: Utils.sorterColumn().sortingOrder(),
          sortComparator: Utils.sorterColumn().sortComparator(
            "MM/YYYY"
          )<String>,
        },
        {
          field: "quantidade",
          headerName: t("common.plannedQuantity"),
          type: "number",
          width: 160,
          editable: false,
          align: "center",
          headerAlign: "center",
          valueFormatter: (params) => round3(params.value) + " Kg",
        },
        {
          field: "quantidadeProposta",
          headerName: t("common.proposedQuantity"),
          type: "number",
          width: 150,
          editable: false,
          align: "right",
          headerAlign: "center",
          valueFormatter: (params) => round3(params.value) + " Kg",
        },
        {
          field: "justificativa",
          headerName: t("common.justify"),
          width: 200,
          editable: false,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => <SkuDescricao value={params.value} />,
        },
        {
          field: "gerouForecastDiario",
          headerName: t("common.generatedDiary"),
          width: 150,
          editable: false,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => params.value,
        },
      ];
    }
    return cols;
  }

  function round3(value: number) {
    return value ? stripZeros(value.toFixed(3)) : 0;
  }

  function stripZeros(str: string) {
    return parseFloat(str.replace(",", ".")).toString().replace(".", ",");
  }

  function createData(
    id: number,
    codigoFornecedorSap: number,
    numeroContrato: string,
    idSku: string,
    descricao: string,
    centro: string,
    anoMesRef: string,
    quantidade: number,
    quantidadeProposta: number,
    justificativa: string,
    gerouForecastDiario: string,
    projeto: string,
    origem: string,
    siglaSku: string
  ): Data {
    return {
      id,
      codigoFornecedorSap,
      numeroContrato,
      idSku,
      descricao,
      centro,
      anoMesRef,
      quantidade,
      quantidadeProposta,
      justificativa,
      gerouForecastDiario,
      projeto,
      origem,
      siglaSku,
    };
  }

  function preencherGrid(_data: Forecast[]) {
    setRows(
      _data.map((item: Forecast) => {
        return createData(
          Number(item.id),
          Number(item.codigoFornecedorSap),
          String(item.numeroContrato),
          String(item.idSku),
          String(item.skuDescricao),
          String(item.centro),
          String((Number(item.anoMesRef) / 100).toFixed(2))
            .split(".")
            .reverse()
            .join("/"), //202304 -> 2023.04 -> [2023,04] -> [04,2023] -> 04/2023
          Number(item.quantidade),
          Number(item.quantidadeProposta),
          String(item.justificativa),
          item.gerouForecastDiario ? t("common.yes") : t("common.no"),
          item.projeto,
          item.origem,
          item.siglaSku
        );
      })
    );
  }

  const Mensagem = (
    titulo: string,
    mensagem: string,
    refresh: boolean = true
  ) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: "Ok",
          onClick: () => {
            setOpen(false);
            if (refresh) {
              PageHelper.refreshPage();
            }
          },
        },
      ],
    });
  };

  function MensagemBackgoundProcess(records: number) {
    var segundos: number = (35000 * records) / 3000 / 1000;
    Mensagem(
      t("common.informative"),
      `${t(
        "pages.monthlyForecast.text.processingRequest"
      )} ${" + Number(segundos).toFixed(2) + "} ${t(
        "pages.monthlyForecast.text.processingRequest2"
      )}`,
      false
    );
  }

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpenDownloadCSV = () => {
    setOpenDownloadCSVModal(true);
  };

  function handleCloseDownloadCSVModal() {
    setOpenDownloadCSVModal(false);
  }

  function handleClickOpenCSVDetalhesModal() {
    setOpenCSVDetalhesModal(true);
  }

  function handleCloseCSVDetalhesModal() {
    setOpenCSVDetalhesModal(false);
  }

  const handleCloseSnackBar = () => {
    setOpenSnackBar(false);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  function handleSelectionChange(ids: any) {
    if (ids !== null && ids !== undefined && ids.length > 0) {
      localStorage.setItem("idsForecast", ids);
      setHabilita(true);
    } else {
      localStorage.removeItem("idsForecast");
      setHabilita(false);
    }
  }

  function FileUploadPage() {
    return (
      <div>
        <FileUpload
          {...{
            endpoint:
              "Forecast/ProcessarPlanilha/Parceiro/" +
              codigoFornecedorSap +
              "/Contrato/" +
              numeroContrato +
              "/Passo/" +
              step,
            setCsvFoiEnviado: setCsvFoiEnviado,
          }}
        />
      </div>
    );
  }

  const handleCellEdtStart = (params: any) => {
    SetValorAnterior(
      step === 1 ? params.row.quantidade : params.row.quantidadeProposta
    );
    console.log(JSON.stringify(params));
  };

  const handleRowEditCommit = (params: any) => {
    if (
      params.field === "quantidade" ||
      params.field === "quantidadeProposta" ||
      params.field === "justificativa"
    ) {
      const index = forecasts.findIndex((f) => f.id === params.id);

      if (index >= 0) {
        if (
          (params.field === "quantidade" ||
            params.field === "quantidadeProposta") &&
          Number(params.value) < 0
        ) {
          alert(t("pages.monthlyForecast.text.negativeValues"));
          const updatedForecast =
            params.field === "quantidade"
              ? { ...forecasts[index], quantidade: valorAnterior }
              : params.field === "quantidadeProposta"
              ? { ...forecasts[index], quantidadeProposta: valorAnterior }
              : undefined;
          if (updatedForecast !== undefined) {
            const tempRows = [
              ...forecasts.slice(0, index),
              updatedForecast,
              ...forecasts.slice(index + 1),
            ];
            setForecasts(tempRows);
            preencherGrid(tempRows);
          }
        } else {
          const row = forecasts[index] as any;
          if (params.field in row && row[params.field] !== params.value) {
            const tempRows = [...forecasts] as any;
            tempRows[index][params.field] = params.value;
            setForecasts(tempRows);
            preencherGrid(tempRows);
          }
        }
      }
    }
  };

  const [openFilter, setOpenFilter] = React.useState(false);

  const handleClickOpenFilter = () => {
    setFilter({} as FilterProps);
    setOpenFilter(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  const handleClickFilter = () => {
    if (filtra) {
      setForecasts(forecasts);
      preencherGrid(forecasts);
    } else {
      handleClickOpenFilter();
    }
    setFiltra(!filtra);
  };

  const handleFilter = async () => {
    const requestData = {
      ...filter,
      numeroContrato: numeroContrato,
      [FILTER_NAMES.mesAnoReferencia]:
        filter[FILTER_NAMES.mesAnoReferencia]
          ?.toLocaleDateString("pt-BR")
          .substring(3)
          .split("/")
          .reverse()
          .join("") || "",
      [FILTER_NAMES.codigoSku]:
        (filter[FILTER_NAMES.codigoSku] || []).length > 0
          ? filter[FILTER_NAMES.codigoSku]
              ?.map((item) => item.split(" - ")[0])
              .join(",")
          : null,
    };

    const filtered: Forecast[] = await dataForecast.RecuperarPorFiltros(
      requestData,
      codigoFornecedorSap,
      _step
    );

    if (filtered.length > 0) {
      setForecasts(filtered);
      preencherGrid(filtered);
    } else {
      preencherGrid([]);
    }

    setOpenFilter(false);
  };

  const getDownloadColumns = () => {
    return columns.filter((x) => x.field != "siglaSku" && x.field != "hist");
  };

  const getDownloadRows = () => {
    return rows.map((row) => {
      return {
        ...row,
        quantidade: (row.quantidade + "").replace(".", ","),
        quantidadeProposta: (row.quantidadeProposta + "").replace(".", ","),
      };
    });
  };

  return (
    <div className={`container ${styles.container}`}>
      <ForecastTopo />
      <div className="containerToolbar">
        {false && step === 1 ? (
          <Tooltip
            title={t("pages.monthlyForecast.text.undoGeneratedForecasts")}
          >
            <span>
              <IconButton
                onClick={handleClickEstornarForecast}
                disabled={loading}
              >
                <ReplayIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}
        {step === 1 || step === 2 ? (
          <Tooltip title={t("pages.monthlyForecast.text.viewRatioData")}>
            <span>
              <IconButton onClick={handleClickDadosForecast} disabled={loading}>
                <AssessmentIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}{" "}
        {!filtra ? (
          <Tooltip
            title={t(
              "pages.monthlyForecast.text.enablesFilteringTheLinesInTheGridBelow"
            )}
          >
            <span>
              <IconButton
                onClick={handleClickFilter}
                disabled={!(rows.length >= 0) || loading}
              >
                <FilterAltIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : (
          <Tooltip
            title={t(
              "pages.monthlyForecast.text.disableFilteringTheLinesInTheGridBelow"
            )}
          >
            <span>
              <IconButton
                onClick={handleClickFilter}
                disabled={!filtra || loading}
              >
                <FilterAltOffIcon />
              </IconButton>
            </span>
          </Tooltip>
        )}
        {step === 1 || step === 2 ? (
          <Tooltip title={t("pages.monthlyForecast.text.saveChanges")}>
            <span>
              <IconButton
                onClick={handleClickSave}
                disabled={!habilita || loading || user.isSuporte}
              >
                <SaveIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}{" "}
        {step <= 3 ? (
          <Tooltip title={t("pages.monthlyForecast.text.uploadCsv")}>
            <span>
              <IconButton
                onClick={handleClickOpen}
                disabled={loading || user.isSuporte}
              >
                <FileUploadIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}{" "}
        {step <= 3 ? (
          <Tooltip title={t("pages.monthlyForecast.text.downloadCsv")}>
            <span>
              <IconButton
                onClick={handleClickOpenDownloadCSV}
                disabled={loading || user.isSuporte}
              >
                <Download />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}{" "}
        {(step < 4 && (user.isPlanejamentoBRF || user.isRoot)) || step == 2 ? (
          <Tooltip title={titleAprova}>
            <span>
              <IconButton
                onClick={() =>
                  handleConfimation(
                    t("pages.monthlyForecast.titlePage"),
                    t("pages.monthlyForecast.text.continueForecast")
                  )
                }
                disabled={!habilita || loading || user.isSuporte}
              >
                <Send />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}{" "}
        {step === 3 && (user.isPlanejamentoBRF || user.isRoot) ? (
          <Tooltip title={t("pages.monthlyForecast.text.reproveData")}>
            <span>
              <IconButton
                onClick={handleClickNotAprove}
                disabled={!habilita || loading || user.isSuporte}
              >
                <NotInterestedIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}{" "}
        {step === 3 && (user.isPlanejamentoBRF || user.isRoot) ? (
          <Tooltip title={t("pages.monthlyForecast.text.sendDataToSap")}>
            <span>
              <IconButton
                onClick={handleIntegracaoPlanoBase}
                disabled={!habilita || loading || user.isSuporte}
              >
                <IntegrationInstructionsIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}{" "}
      </div>

      <div className={`divFlow ${styles.table}`}>
        <div className={styles.table}>
          <DataGrid
            loading={loading}
            rows={rows}
            columns={columns}
            rowsPerPageOptions={[50, 100, 250, 500]}
            onSelectionModelChange={(ids) => {
              handleSelectionChange(ids);
            }}
            onCellEditCommit={handleRowEditCommit}
            onCellEditStart={handleCellEdtStart}
            checkboxSelection={step != 4}
            disableSelectionOnClick
            initialState={{
              sorting: {
                sortModel: [{ field: "anoMesRef", sort: "asc" }],
              },
            }}
          />
        </div>
      </div>
      {user.isRoot && (
        <div className="divFlow">
          <ForecastPassoAPasso {...{ data: step }} />
        </div>
      )}

      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {t("pages.monthlyForecast.text.importExcel")}
            <br />
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <br />
              {FileUploadPage()}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              color="success"
              onClick={handleClose}
              autoFocus
            >
              {t("common.close")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <div>
        <Dialog
          open={openFilter}
          onClose={handleCloseFilter}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          id="filter"
        >
          <DialogTitle id="alert-dialog-title">
            {t("common.filter")}
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2} mt={2}>
              <Grid item xs={12}>
                {/* <TextField
                  id={"CodSku"}
                  label="Código SKU"
                  placeholder="Código Sku"
                  variant="outlined"
                  name={FILTER_NAMES.codigoSku}
                  value={filter[FILTER_NAMES.codigoSku]}
                  onChange={handleChangeFilter}
                  fullWidth
                /> */}
                <AutocompleteSKU
                  multiple
                  onChangeCallback={(e, newValue) => {
                    handleChangeFilter({
                      target: { name: FILTER_NAMES.codigoSku, value: newValue },
                    });
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id={"DesSku"}
                  label={t("common.skuDescription.label")}
                  placeholder={t("common.skuDescription.label")}
                  variant="outlined"
                  name={FILTER_NAMES.descricaoSku}
                  value={filter[FILTER_NAMES.descricaoSku]}
                  onChange={handleChangeFilter}
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id={"Centro"}
                  label={t("common.distributionCenter")}
                  placeholder={t("common.distributionCenter")}
                  variant="outlined"
                  name={FILTER_NAMES.centroDistribuicao}
                  value={filter[FILTER_NAMES.centroDistribuicao]}
                  onChange={handleChangeFilter}
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  locale={ptBR}
                >
                  <DatePicker
                    label={
                      <div className={styles["datepicker-label"]}>
                        Mês e ano referência
                      </div>
                    }
                    value={filter[FILTER_NAMES.mesAnoReferencia]}
                    views={["month", "year"]}
                    onChange={(newValue: any) => {
                      handleChangeFilter({
                        target: {
                          name: FILTER_NAMES.mesAnoReferencia,
                          value: newValue,
                        },
                      });
                    }}
                    inputFormat="MM/yyyy"
                    renderInput={(params: any) => (
                      <TextField
                        {...params}
                        size="small"
                        {...(!!filter[FILTER_NAMES.mesAnoReferencia] && {
                          value: filter[FILTER_NAMES.mesAnoReferencia]
                            ?.toLocaleDateString("pt-BR")
                            .substring(3),
                        })}
                        onChange={(event) => {
                          const value = event.target.value;
                          if (value.length === 7) {
                            try {
                              handleChangeFilter({
                                target: {
                                  name: FILTER_NAMES.mesAnoReferencia,
                                  value: new Date(
                                    Number(value.split("/")[1]),
                                    Number(value.split("/")[0]) - 1
                                  ),
                                },
                              });
                            } catch (err) {
                              console.log("wrong value to date: ", value);
                            }
                          } else {
                            handleChangeFilter({
                              target: {
                                name: FILTER_NAMES.mesAnoReferencia,
                                value: null,
                              },
                            });
                          }
                        }}
                        inputProps={{
                          placeholder: "04/2022",
                          className: styles["datepicker-height"],
                        }}
                        {...(!!filter[FILTER_NAMES.mesAnoReferencia] && {
                          InputLabelProps: {
                            shrink: true,
                          },
                        })}
                      />
                    )}
                    className={styles["datepicker-full"]}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id={"Quantidade"}
                  label={t("common.quantity")}
                  placeholder={t("common.quantity")}
                  variant="outlined"
                  // value={quantidade}
                  // name={"Quantidade"}
                  // onChange={(event) =>setQuantidade(event.target.value)}
                  value={filter[FILTER_NAMES.quantidade]}
                  name={FILTER_NAMES.quantidade}
                  onChange={handleChangeFilter}
                  fullWidth
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Grid justifyContent="space-between" container padding={2}>
              <Grid item>
                <Button
                  variant="outlined"
                  color="inherit"
                  onClick={handleCloseFilter}
                  autoFocus
                  className={"button-close-dialog"}
                >
                  {t("common.close")}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  color="success"
                  onClick={handleFilter}
                  autoFocus
                >
                  {t("common.filtered")}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      </div>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        }}
      >
        <ForecastModal handleClose={handleCloseModal} forecasts={forecasts} />
      </Modal>
      <Snackbar
        open={openSnackBar}
        autoHideDuration={6000}
        onClose={handleCloseSnackBar}
      >
        <Alert
          onClose={handleCloseSnackBar}
          severity={csvFoiEnviado.isSuccess ? "success" : "error"}
          sx={{ width: "100%" }}
          action={
            <Button
              color="primary"
              size="small"
              onClick={handleClickOpenCSVDetalhesModal}
            >
              {t("common.seeDetails")}
            </Button>
          }
        >
          {csvFoiEnviado.isSuccess
            ? t("pages.monthlyForecast.text.csvWithSuccess")
            : t("pages.monthlyForecast.text.csvWithError")}
        </Alert>
      </Snackbar>
      <Modal
        open={openDownloadCSVModal}
        onClose={handleCloseDownloadCSVModal}
        sx={{
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        }}
      >
        <DownloadCSVModal
          handleClose={handleCloseDownloadCSVModal}
          rows={getDownloadRows()}
          columns={getDownloadColumns()}
          name={`${t("pages.monthlyForecast.titlePage")} Step ${step}`}
        />
      </Modal>

      <Modal
        open={openCSVDetalhesModal}
        onClose={handleCloseCSVDetalhesModal}
        sx={{
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        }}
      >
        <CSVDetalhesModal
          handleClose={handleCloseCSVDetalhesModal}
          name={`${t("pages.dailyForecast.titlePage")} Step ${step}`}
          detalhes={csvFoiEnviado.details}
        />
      </Modal>

      {historyId > 0 && (
        <StepLogsHistoryDetalhe
          id={historyId}
          type={"ForecastMensal"}
          onClose={() => setHistoryId(0)}
        />
      )}
    </div>
  );
}
